<template>
    <div :class="classComputedName">
        <div class="strategy_select_title">
            <p class="pick-title">策略选股 <template v-if="showPick"><input id="pick_date" type="text" readonly="readonly" class="pick_date" v-model="pickDate" @click="showTradeDateDialog($event, maxDate, '2014-1-1')" /></template>
                <template v-else>（{{ pickDate }}）</template>
            </p>
            <p class="pick-item">仓位控制：{{ position }}</p>
            <p v-if="transactiontype === '2'" class="pick-item">次日市场：{{ (pickStock !== null && pickStock.market !== null) ? (pickStock.market > 0 ? '强势行情' : '弱势行情') : '--' }}</p>
        </div>
        <table cellspacing="0">
            <thead>
                <th>股票代码</th>
                <th>股票简称</th>
                <th>涨跌幅</th>
                <th>当日收盘价（元）</th>
                <th>dde大单净量（%）</th>
                <th>股本规模</th>
                <th>换手率</th>
            </thead>
        </table>
        <EasyScrollbar :barOption="myBarOption">
            <div class="rolltable" v-if="pickStock !== null">
                <table cellspacing="0">
                    <tbody v-if="pickStock.stocks.length !== 0">
                        <tr v-for="(selet, index) in pickStock.stocks" :class="(index + 1) % 2 === 0 ? 'gray' : ''">
                            <td width="124">{{ selet.stock_code | slicetwo }}</td>
                            <td width="124"
                                class="td-highlight"
                                @click="codeLink(selet.stock_code)"
                                @mouseenter="debounceShowQuoteChart($event, selet)"
                                @mouseleave="hideQuoteChart(selet)"
                                >{{ selet.stock_name }}</td>
                            <td width="93" :class="selet.change_rate | riseAndFallClass">{{ selet.change_rate | safeFloatPerFixedTwo }}</td>
                            <td width="248">{{ selet.close_price | safeFloatFixedTwo }}</td>
                            <td width="271">{{ selet.dde | safeFloatFixedTwo }}</td>
                            <td width="124">{{ selet.equit_scale }}</td>
                            <td width="94">{{ selet.turnover_rate | safeFloatPerFixedTwo }}</td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="7">今日无选股</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </EasyScrollbar>
    </div>
</template>

<script>
    import axios from 'axios'
    import { showTradeDateDialog } from '@/lib/wDatePicker.js'
    import quoteChart from '@/lib/quoteChartVue.js'
    import { debounce } from 'lodash'
    export default {
        data () {
            var self = this
            var debounceShowQuoteChart = debounce(function () {
                // 鼠标还停留在dom上
                if (arguments[0].target.contains(self.$mousemoveEvent.target)) {
                    self.showQuoteChart(...arguments)
                }
            }, 1000)
            return {
                debounceShowQuoteChart,
                myBarOption: {
                    // barColor: '#f60', // 滚动条颜色
                    barWidth: 9, // 滚动条宽度
                    // railColor: '#f5f5f5', // 导航颜色
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                    // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                    // zIndex: 'auto', // 滚动条的z-index
                    // autohidemode: true, // 自动隐藏模式
                    horizrailenabled: false // 是否显示水平滚动条
                },
                pickDate: null,
                pickStock: null,
                detailContent: '',
                backtestContent: ''
            }
        },
        computed: {
            maxDate () {
                return this.pickStock ? this.pickStock.maxDate : null
            },
            position () {
                if (this.pickStock === null) {
                    return ''
                }
                if (Number(this.transactiontype) !== 2) {
                    return '满仓'
                } else if (this.pickStock.market === null) {
                    return '--'
                } else if (this.pickStock.market > 0) {
                    return '满仓'
                } else if (this.buyPosition === 100) {
                    return '满仓'
                } else if (this.buyPosition === 0) {
                    return '空仓'
                } else {
                    return this.buyPosition + '%仓位'
                }
            },
            classComputedName () {
                let className = {}
                className[this.classname] = true
                return className
            }
        },
        props: {
            strategyId: String,
            showPick: {
                type: Boolean,
                default: false
            },
            selectData: {
                type: Object,
                default () {
                    return {}
                }
            },
            transactiontype: String,
            buyPosition: {
                type: Number,
                default () {
                    return null
                }
            },
            classname: {
                type: String,
                default () {
                    return 'strategy_select'
                }
            },
            query: String,
            hold: String
        },
        methods: {
            hideQuoteChart (item) {
                quoteChart.hide(item.stock_market.toLowerCase() + '_' + item.stock_code)
            },
            showQuoteChart (event, item) {
                var DOMRect = event.srcElement.getBoundingClientRect()
                quoteChart({
                    code: item.stock_market.toLowerCase() + '_' + item.stock_code,
                    top: DOMRect.top,
                    left: DOMRect.right - 10
                })
            },
            showTradeDateDialog,
            requestHistoryPick () {
                let params = {
                    query: this.query,
                    hold_num: this.hold,
                    trade_date: this.pickDate,
                    menv: this.pickStock.menv
                }
                let self = this
                if (document.getElementsByClassName('strategydetailmain')[0]) {
                    window.TA.log(this.$buriedPoint.strategyDetails.pickStockDate.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.$buriedPoint.strategyBacktest.pickStockDate)
                }
                axios.get('/tradebacktest/historypick', {params}).then((res) => {
                    if (res.data.errorcode === 0) {
                        self.pickStock = res.data.result
                    }
                }).catch(function (error) {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            }
        },
        created () {
            this.pickDate = this.selectData !== null ? this.selectData.date : null
            this.pickStock = this.selectData
        },
        watch: {
            selectData () {
                this.pickDate = this.selectData !== null ? this.selectData.date : null
                this.pickStock = this.selectData
            },
            pickDate (newVal, oldVal) {
                if (oldVal !== null) {
                    this.requestHistoryPick()
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .td-highlight {
        color: #3e76c2 !important;
        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }
    @import '../../scss/strategybacktest/strategy_select.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/strategy-select.vue